define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var ContinuationTrigger;
    (function (ContinuationTrigger) {
        ContinuationTrigger["LOGIN"] = "loginContinuation";
        ContinuationTrigger["LOGOUT"] = "logoutContinuation";
    })(ContinuationTrigger = exports.ContinuationTrigger || (exports.ContinuationTrigger = {}));
    function registeredContinuations(trigger) {
        var actionsJson = window.sessionStorage.getItem(trigger) || '[]';
        var actions = JSON.parse(actionsJson);
        return actions;
    }
    exports.registeredContinuations = registeredContinuations;
    function registerContinuation(trigger, action) {
        var actions = registeredContinuations(trigger).concat([action]);
        window.sessionStorage.setItem(trigger, JSON.stringify(actions));
    }
    exports.registerContinuation = registerContinuation;
    var actionHandlers = {};
    function registerAction(type, handler) {
        actionHandlers[type] = handler;
    }
    exports.registerAction = registerAction;
    function dispatchAction(action) {
        var handler = actionHandlers[action.type];
        return handler ? handler(action) : $.Deferred().reject().promise();
    }
    exports.dispatchAction = dispatchAction;
    function triggerContinuation(trigger) {
        var actions = registeredContinuations(trigger);
        window.sessionStorage.removeItem(trigger);
        var pending = $.map(actions, function (action) { return dispatchAction(action); });
        return $.when(pending);
    }
    exports.triggerContinuation = triggerContinuation;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/contiunation.js
// module id = 15
// module chunks = 0